var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$feature.isEnabled('multilingual_mass_mailling'))?_c('email-composer-v2',{attrs:{"name":_vm.name,"is-forwarding":_vm.isForwarding,"portal":_vm.portal}}):_c('email-composer-v1',{attrs:{"name":_vm.name,"is-forwarding":_vm.isForwarding,"portal":_vm.portal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }